<template>
    <!-- SEARCH BAR -->
    <section
        class="tw-relative tw-bg-[#F9F9F9] tw-px-4 tw-py-16 tw-text-center tw-text-[#00101D] dark:tw-bg-[#002039] dark:tw-text-white md:tw-px-0 md:tw-py-20"
    >
        <div
            class="tw-relative tw-z-0 tw-mx-auto tw-w-full tw-max-w-xl md:tw-max-w-none 3xl:tw-max-w-screen-3xl 4xl:tw-max-w-screen-4xl"
        >
            <h3 class="tw-text-[32px]">
                <strong>Advice and answers from the Musora team</strong>
            </h3>
            <p class="tw-mb-10 tw-mt-2 tw-text-lg">
                Find an answer on your own or get in touch with our support
                team.
            </p>
            <div>
                <form @submit.prevent="handleSearch">
                    <input
                        class="tw-mb-2 tw-mr-2 tw-w-full tw-rounded-full tw-border tw-border-[#D1D5DB] tw-py-3 tw-pl-4 tw-text-black md:tw-mb-0 md:tw-mr-0 md:tw-max-w-lg"
                        placeholder="Search the knowledgebase"
                        id="searchInput"
                    />
                    <br class="md:tw-hidden" />
                    <button
                        type="submit"
                        class="tw-btn-primary tw-bg-[#00101D]"
                    >
                        Search
                    </button>
                </form>
            </div>
        </div>
    </section>

    <!-- FAQ -->
    <section class="tw-bg-[#F4F4F5] tw-py-12 dark:tw-bg-[#000C17] md:tw-py-16">
        <div class="tw-mx-auto tw-max-w-4xl tw-px-4">
            <h3 class="tw-mb-10 tw-text-center dark:tw-text-white">
                <strong>Frequently Asked Questions</strong>
            </h3>
            <div
                class="tw-grid tw-grid-cols-2 tw-gap-3 sm:tw-gap-4 md:tw-grid-cols-3 lg:tw-grid-cols-4"
            >
                <div
                    v-for="question in questions"
                    class="tw-relative tw-rounded-xl tw-bg-[#030814] tw-px-3 tw-py-6 tw-text-center tw-text-white dark:tw-bg-white dark:tw-text-[#000C17] sm:tw-py-9"
                    style="box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.25)"
                >
                    <i
                        :class="`tw-mb-3 tw-text-3xl md:tw-text-4xl ${question.icon}`"
                    ></i>
                    <p class="tw-mb-1 tw-text-sm tw-font-bold">
                        {{ question.title }}
                    </p>
                    <p class="tw-text-sm">{{ question.question }}</p>
                    <a
                        href="#"
                        :data-beacon-article-sidebar="question.beacon"
                        class="tw-absolute tw-inset-0"
                        :aria-label="question.title"
                    ></a>
                </div>
            </div>
        </div>
    </section>

    <!-- FORM -->
    <section
        class="tw-bg-white tw-px-4 tw-py-12 dark:tw-bg-[#081825] dark:tw-text-white md:tw-py-16 lg:tw-px-8"
        id="contactPageApp"
    >
        <div
            class="tw-mx-auto tw-w-full tw-text-center 3xl:tw-max-w-screen-3xl 4xl:tw-max-w-screen-4xl"
        >
            <h3><strong>Reach Out Directly</strong></h3>
            <p
                class="tw-mx-auto tw-mb-5 tw-mt-4 tw-max-w-3xl tw-text-sm md:tw-text-base"
            >
                Get in touch with our support team!
            </p>
            <div class="tw-text-left">
                <div
                    class="tw-mx-auto tw-flex tw-max-w-3xl tw-flex-col tw-px-4"
                >
                    <section
                        class="tw-my-[30px] tw-flex tw-w-full tw-flex-row tw-flex-wrap"
                    >
                        <div class="tw-flex tw-w-full tw-flex-col">
                            <ContactMemberEmailForm
                                :brand="brand"
                                :email-subject="emailSubject"
                                :email-type="emailType"
                                :email-endpoint="emailEndpoint"
                                :email-logo="emailLogo"
                                :email-alert="emailSubject"
                                input-label="Report your issue here.."
                                :lesson-page="false"
                                :recipient="emailRecipient"
                                :success-message="emailSuccessMessage"
                            />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>

    <!-- URGENT REQUEST -->
    <section
        class="tw-bg-[#F4F4F5] tw-px-4 tw-py-12 dark:tw-bg-[#000C17] dark:tw-text-white md:tw-py-16"
    >
        <div class="tw-mx-auto tw-max-w-4xl">
            <h3 class="tw-mb-7 tw-text-center">
                <strong>Have A More Urgent Request? Give Us A Shout.</strong>
            </h3>
            <div
                class="tw-mx-auto tw-max-w-sm md:tw-grid md:tw-max-w-none md:tw-grid-cols-3 md:tw-gap-6"
            >
                <div
                    class="tw-flex tw-items-center tw-px-2 tw-py-4 md:tw-justify-center md:tw-rounded-xl md:tw-border md:tw-border-[#AAACAA] md:tw-py-6"
                >
                    <i
                        class="fa-regular fa-phone-volume tw-mr-6 tw-text-3xl"
                    ></i>
                    <div class="tw-text-sm">
                        <strong class="tw-font-bold">Toll Free:</strong>
                        <br class="tw-hidden md:tw-inline" />
                        1-800-439-8921
                    </div>
                </div>
                <div
                    class="tw-flex tw-items-center tw-px-2 tw-py-4 md:tw-justify-center md:tw-rounded-xl md:tw-border md:tw-border-[#AAACAA] md:tw-py-6"
                >
                    <i class="fa-regular fa-globe tw-mr-6 tw-text-3xl"></i>
                    <div class="tw-text-sm">
                        <strong class="tw-font-bold"
                            >Direct/International:</strong
                        >
                        <br class="tw-hidden md:tw-inline" />
                        1-604-855-7605
                    </div>
                </div>
                <div
                    class="tw-flex tw-items-center tw-px-2 tw-py-4 md:tw-justify-center md:tw-rounded-xl md:tw-border md:tw-border-[#AAACAA] md:tw-py-6"
                >
                    <i class="fa-regular fa-clock tw-mr-6 tw-text-3xl"></i>
                    <div class="tw-text-sm">
                        <strong class="tw-font-bold">Office Hours:</strong>
                        <br class="tw-hidden md:tw-inline" />
                        Monday - Friday<br />
                        8AM - 4PM Pacific Time
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useUserStore } from "@stores/user";
import ContactMemberEmailForm from "@vuesora/Components/ContactMemberEmailForm/ContactMemberEmailForm";

const userStore = useUserStore();
const { brand } = storeToRefs(userStore);

const props = defineProps({
    emailRecipient: {
        type: String,
        default: null,
    },
    emailLogo: {
        type: String,
        default: null,
    },
    emailSubject: {
        type: String,
        default: () => "",
    },
    emailType: {
        type: String,
        default: () => "",
    },
    emailEndpoint: {
        type: String,
        default: () => "",
    },
    emailSuccessMessage: {
        type: String,
        default: () => "",
    },
});

const handleSearch = () => {
    const keyword = document.getElementById("searchInput").value;
    if (keyword) {
        window.location = `https://faq.musora.com/search?query=${keyword}`;
    }
};

const questions = [
    {
        title: "Instructor Feedback",
        question: "How can I get personalized feedback from my instructor?",
        beacon: "66b3a3187c359113ce1adb42",
        icon: "fa-regular fa-comments",
    },
    {
        title: "Shipment Tracking",
        question: "I ordered a product from you, how can I track my shipment?",
        beacon: "6809222bd124442b67ec0540",
        icon: "fa-sharp fa-regular fa-truck-fast",
    },
    {
        title: "Download Lessons",
        question: "How do I download or print sheet music and chord charts?",
        beacon: "66474f7f78142106434403cf",
        icon: "fa-sharp fa-regular fa-download",
    },
    {
        title: "Downloading Sheet Music",
        question: "How do I download or print sheet music and chord charts?",
        beacon: "634b2887de258f5018eb4af3",
        icon: "fa-regular fa-file-music",
    },
    {
        title: "Determine skill level",
        question: "How do I know if I’m a beginner, intermediate, or advanced?",
        beacon: "680ab4f26e0978310cd40d95",
        icon: "fa-solid fa-question",
    },
    {
        title: "Billing Information",
        question: "Where can I find my billing history and invoices?",
        beacon: "657a2e82e4d9c14e590b9f9a",
        icon: "fa-regular fa-file-invoice-dollar",
    },
    {
        title: "End membership",
        question: "How can I make sure my subscription doesn't renew?",
        beacon: "6626f91bdd199d110372a440",
        icon: "fa-light fa-circle-xmark",
    },
    {
        title: "Request a Refund",
        question:
            "I purchased less than 90 days ago and I would like a refund.",
        beacon: "663bb2ca0d8e3e7142b1023c",
        icon: "fa-regular fa-circle-dollar",
    },
];
</script>
